import { concat } from 'lodash';

import apiFetch from 'modules/api-fetch';

type NFChatMessage = import('modules/typescript').NFChatMessage;

const markMessagesAsSeen = async (
  messages: NFChatMessage[],
  clientAspNetUserId: string,
): Promise<void> => {
  const newlySeenMessagesIds = messages.reduce(
    (acc: number[], cur: NFChatMessage) =>
      cur.seenByClient === null && cur.aspNetUserId !== clientAspNetUserId
        ? concat(acc, cur.id)
        : acc,
    [],
  );

  if (newlySeenMessagesIds.length <= 0) {
    return;
  }

  const config = {
    url: 'Client/UpdateMessagesSeenByClient',
    method: 'POST',
    body: newlySeenMessagesIds,
  };

  try {
    await apiFetch(config);
  } catch (e) {
    console.devLog.info('Error updating seen messages:', e);
  }
};

export default markMessagesAsSeen;
